
import { Toaster } from '@/services/toast';
import Vue from 'vue';

export default Vue.extend({
  name: 'NafathNumberChallenge',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    sendRequest: {
      type: [String, Object],
      required: true,
    },
    checkRequest: {
      type: [String, Object],
      required: true,
    },
    idNumber: {
      type: String,
      required: false,
    },
    sendOnMount: {
      type: Boolean,
      default: false,
    },
    sendNafathRequestDto: {
      type: Object,
      required: false,
    },
    oldAttr: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: this.value,
      random: null,
      transId: '',
      errorMessage: '',
      status: null,
      intervalId: 0,
      timeoutId: 0,
      loading: false,
    };
  },
  methods: {
    async sendRequestFn() {
      // let response;
      // this.reset();
      try {
        // if (this.sendRequest instanceof Request) {
        //   response = await fetch(this.sendRequest);
        // } else {
        //   response = await fetch(this.sendRequest, {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({ idNumber: this.idNumber }),
        //   });
        // }

        // const json = response ? await response.json() : {} as any;

        this.showLoading();
        let response = await this.fetchData(this.sendRequest, this.sendNafathRequestDto ? this.sendNafathRequestDto : { idNumber: this.idNumber });
        this.hideLoading();

        if (response) {
          this.random = response.random;
          this.transId = response.transId
          this.startRequestChecking();
          // } else {
          //   this.errorMessage = json.errorMessage ? json.errorMessage : 'حدث خطأ أثناء تنفيذ العملية. يرجى المحاولة مرة أخرى.';
        }
      } catch (error) {
        console.error('Error sending request:', error);
        this.errorMessage = 'حدث خطأ أثناء تنفيذ العملية. يرجى المحاولة مرة أخرى.';
      }
    },
    startRequestChecking() {
      this.clearTimers();
      this.intervalId = setInterval(() => this.checkRequestFn(), 7000) as any;
      this.timeoutId = setTimeout(() => this.clearTimers(), 300000) as any;
    },
    async checkRequestFn() {
      try {
        // const response = await fetch(`${this.checkRequest}/${this.transId}`);
        // const json = await response.json();
        let response = await this.fetchData(`${this.checkRequest}/${this.transId}`, 
        this.oldAttr ? { OtpReference: this.transId, OtpValue: this.random, IdentityNumber: this.idNumber } : {});

        if (response) {
          this.status = (response.status || '').toLowerCase();

          if (this.status !== 'waiting') {

            if (this.status == 'expired') {
              Toaster.error('تم انتهاء وقت طلب التحقق في تطبيق نفاذ');
            } else if (this.status == 'rejected') {
              Toaster.error('تم رفض طلب التحقق في تطبيق نفاذ');
            } else {
              this.$emit('status-changed', {
                random: this.random,
                transId: this.transId,
                ...response
              });
            }

            this.visible = false;
            this.reset();
            this.$emit('input', this.visible);
          }
          // } else {
          //   this.errorMessage = json.errorMessage ? json.errorMessage : 'حدث خطأ أثناء تنفيذ العملية. يرجى المحاولة مرة أخرى.';
        }
      } catch (error) {
        console.error('Error checking request:', error);
        this.errorMessage = 'حدث خطأ أثناء تنفيذ العملية. يرجى المحاولة مرة أخرى.';
      }
    },
    async fetchData(url: any, data: any) {
      try {
        const response = await fetch(`${process.env.BASE_URL}${url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });

        const contentType = response.headers.get('Content-Type');

        let result;
        if (contentType && contentType.includes('application/json')) {
          // Parse JSON
          result = await response.json();
        } else {
          // Handle as plain text
          result = await response.text();
          if (!response.ok) {
            this.errorMessage = result ? result : 'حدث خطأ أثناء تنفيذ العملية. يرجى المحاولة مرة أخرى.';
          }
        }

        if (!response.ok) {
          return null;
        }

        return result;

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    showLoading() {
      if (window && window.ShowLoader) {
        window.ShowLoader();
        // } else if (window.showLoader) {
        //   window.showLoader();
      }
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
      if (window && window.HideLoader) {
        window.HideLoader();
        // } else if (window.hideLoader) {
        //   window.hideLoader();
      }
    },
    open() {
      this.startRequestChecking();
      this.visible = true;
      this.$emit('input', true);
    },
    cancel() {
      this.visible = false;
      this.reset();
      this.$emit('input', false);
    },
    reset() {
      this.errorMessage = '';
      this.random = null;
      this.clearTimers();
    },
    clearTimers() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = 0;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = 0;
      }
    },
  },
  watch: {
    value(val) {
      this.visible = val;

      this.visible ? this.sendRequestFn() : this.reset();
      // this.visible ? this.checkRequestFn() : this.reset();
    },
  },
  async mounted() {
    if (this.sendOnMount) {
      await this.sendRequestFn();
    }
  },
  beforeDestroy() {
    this.reset();
  },
});
